module.exports = __webpack_public_path__ + "static/media/pirenopolis-go.55b4197f.jpg";